import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RsfComponent } from './rsf.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {
  ErrorStateMatcher,
  MatNativeDateModule,
  MatOptionModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ControlsModule } from 'src/app/controls/controls.module';
import { SharedModule } from 'src/app/modules/shared.module';
import { ChecklistsModule } from '../checklists/checklists.module';
import { RedirectGuard } from 'src/app/common/guards/redirect.guard';
import { AppComponent } from 'src/app/app.component';
import { TouchedErrorStateMatcher } from '../pending-approvals-v2/pending-approvals-v2.module';
import { RsfSideComponent } from './rsf-side/rsf-side.component';
import { RsfMainComponent } from './rsf-main/rsf-main.component';
import { RsfToolbarComponent } from './rsf-toolbar/rsf-toolbar.component';
import { RsfMainButtonsComponent } from './rsf-main/rsf-main-buttons/rsf-main-buttons.component';
import { RsfMainS2Component } from './rsf-main/rsf-main-s2/rsf-main-s2.component';
import { httpInterceptorProviders } from 'src/app/common/interceptors/interceptorProviders';
import { AuthenticationGuard } from 'src/app/common/guards/authentication.guard';
import { UnsavedChangesGuard } from 'src/app/common/guards/unsaved-changes.guard';
import { RsfMainS3Component } from './rsf-main/rsf-main-s3/rsf-main-s3.component';
import { RsfMainS4Component } from './rsf-main/rsf-main-s4/rsf-main-s4.component';
import { RsfMainS5Component } from './rsf-main/rsf-main-s5/rsf-main-s5.component';
import { RsfMainS6Component } from './rsf-main/rsf-main-s6/rsf-main-s6.component';
import { RsfMainSBaseComponent } from './rsf-main/rsf-main-s-base/rsf-main-s-base.component';
import { RsfButtonsComponent } from './rsf-buttons/rsf-buttons.component';
import { RsfSettingsComponent } from './rsf-settings/rsf-settings.component';
import { RsfSettingsRoleNotificationsComponent } from './rsf-settings/rsf-settings-role-notifications/rsf-settings-role-notifications.component';
import { RsfSettingsResourceTypesComponent } from './rsf-settings/rsf-settings-resource-types/rsf-settings-resource-types.component';
import { RsfHoldPointDashboardComponent } from './rsf-hold-point-dashboard/rsf-hold-point-dashboard.component';

const appRoutes: Routes = [
  {
    path: 'rsf',
    component: RsfComponent,
    canDeactivate: [UnsavedChangesGuard, RedirectGuard],
    canActivate: [AuthenticationGuard],
  },
  // Expose hold-point status as a dedicated RSF page opened from the RSF side buttons.
  {
    path: 'rsf-hold-points',
    component: RsfHoldPointDashboardComponent,
    canActivate: [AuthenticationGuard],
  },
];

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

@NgModule({
  declarations: [
    RsfComponent,
    RsfMainComponent,
    RsfSideComponent,
    // RsfMainS1Component,
    RsfToolbarComponent,
    RsfMainButtonsComponent,
    // RsfMainS1CheckcardComponent,
    // RsfMainS1NotificationsComponent,
    // RsfMainS1SystemsAffectedComponent,
    // RsfMainS1FunctionalTestsComponent,
    RsfMainS2Component,
    RsfMainS3Component,
    RsfMainS4Component,
    RsfMainS5Component,
    RsfMainS6Component,
    RsfMainSBaseComponent,
    RsfButtonsComponent,
    RsfSettingsComponent,
    RsfSettingsRoleNotificationsComponent,
    RsfSettingsResourceTypesComponent,
    // Register the routed RSF hold-point dashboard with the RSF module.
    RsfHoldPointDashboardComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    HttpClientModule,
    ScrollingModule,
    HttpClientModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    DragDropModule,
    MatTreeModule,
    MatExpansionModule,
    MatOptionModule,
    MatSidenavModule,
    // Needed by the RSF hold-point dashboard toolbar.
    MatToolbarModule,
    MatTooltipModule,
    QuillModule.forRoot(),
    SharedModule,
    ControlsModule,
    ChecklistsModule,
    RouterModule.forRoot(appRoutes, {
      enableTracing: true,
      useHash: true,
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance,
    },
    httpInterceptorProviders,
    { provide: ErrorStateMatcher, useClass: TouchedErrorStateMatcher },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RsfModule { }
